import React, { useContext } from 'react';
import styled from '@emotion/styled/macro';
import { ThemeContext } from '../context/ThemeContext';

const NavbarWrapper = styled.nav`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background: ${({ theme }) => theme.navBackground};
  color: ${({ theme }) => theme.navTextColor};
  border-bottom: 1px solid ${({ theme }) => theme.line || 'rgba(12,12,12,0.12)'};
  z-index: 1000;
  padding: 1.1rem 2.4rem;

  @media (max-width: 768px) {
    display: none;
  }
`;

const NavContainer = styled.div`
  max-width: 1180px;
  margin: 0 auto;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
`;

const Brand = styled.div`
  font-family: ${({ theme }) => theme.headingFont || 'serif'};
  font-size: 1rem;
  letter-spacing: 0.16em;
  text-transform: uppercase;
`;

const NavLinks = styled.ul`
  display: flex;
  list-style: none;
  gap: 1.5rem;
  margin: 0;
  padding: 0;

  a {
    color: ${({ theme }) => theme.navTextColor};
    font-size: 0.9rem;
    font-weight: 600;
    letter-spacing: 0.1em;
    text-transform: uppercase;
  }
`;

const ToggleWrapper = styled.button`
  width: 60px;
  height: 30px;
  border-radius: 0;
  background: transparent;
  border: 1px solid ${({ theme }) => theme.line || 'rgba(12,12,12,0.12)'};
  display: flex;
  align-items: center;
  justify-content: ${({ isDark }) => (isDark ? 'flex-end' : 'flex-start')};
  padding: 4px;
  cursor: pointer;
  transition: border-color 0.3s ease, background 0.3s ease;
  color: ${({ theme }) => theme.navTextColor};
`;

const ToggleCircle = styled.span`
  width: 20px;
  height: 20px;
  border-radius: 0;
  background: ${({ theme }) => theme.accent || '#c8102e'};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 0.7rem;
  color: #fff;
  transition: transform 0.3s ease, background 0.3s ease;
`;

function Navbar() {
  const { toggleTheme, theme, isDark } = useContext(ThemeContext);

  return (
    <NavbarWrapper id="desktop-nav">
      <NavContainer>
        <Brand>Lukas Sivak</Brand>
        <NavLinks>
          <li><a href="#about">About</a></li>
          <li><a href="#experience">Experience</a></li>
          <li><a href="#projects">Projects</a></li>
          <li><a href="#contact">Contact</a></li>
        </NavLinks>

        <ToggleWrapper theme={theme} isDark={isDark} onClick={toggleTheme} aria-label="Toggle theme">
          <ToggleCircle theme={theme}>{isDark ? '☾' : '☀'}</ToggleCircle>
        </ToggleWrapper>
      </NavContainer>
    </NavbarWrapper>
  );
}

export default Navbar;
